import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * Red de seguridad de la UI. Sin esto, un error de render en cualquier página deja
 * PANTALLA BLANCA (nos pasó con el shim de `global`): la app entera desaparece y el
 * usuario no tiene forma de salir. Con esto, el error queda contenido y se ofrece
 * una salida (recargar).
 *
 * Los error boundaries DEBEN ser componentes de clase — no hay equivalente en hooks.
 */
interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // Queda en la consola para diagnóstico; a futuro, enviar a un colector.
    console.error("ErrorBoundary atrapó un error de render:", error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="center-msg" role="alert">
          <h2>Algo salió mal</h2>
          <p>Ocurrió un error inesperado en la aplicación. Puedes recargar para continuar.</p>
          <button className="btn-primary" onClick={() => window.location.reload()}>
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
